import { BonificoOrderDTO, VatExemption } from "./BonificoOrderDTO.ts";
import { BusinessType } from "../../MoneyTransfer/BusinessType.tsx";
import { isOutsideItalianVatTerritory } from "../../MoneyTransfer/billingCountries.ts";

const BUSINESS_TYPES_INVOICED_WITHOUT_VAT_ABROAD: string[] = [
  BusinessType.Company,
  BusinessType.IndividualCompany,
];

export function isArticle7TerSuggestedFor({
  businessType,
  country,
}: {
  businessType?: string;
  country?: string;
}): boolean {
  return (
    BUSINESS_TYPES_INVOICED_WITHOUT_VAT_ABROAD.includes(businessType ?? "") &&
    isOutsideItalianVatTerritory(country)
  );
}

export function isArticle7Ter(vatExemption?: VatExemption | null): boolean {
  return vatExemption === VatExemption.Article7Ter;
}

export function vatExemptionFor(
  isArticle7TerApplied: boolean,
): VatExemption | null {
  return isArticle7TerApplied ? VatExemption.Article7Ter : null;
}

export function describeIssuedInvoiceVat(
  order: Pick<BonificoOrderDTO, "invoiceIssuedAtUtc" | "invoiceVatExemption">,
): string | undefined {
  if (!order.invoiceIssuedAtUtc) return undefined;
  return isArticle7Ter(order.invoiceVatExemption)
    ? "La fattura è stata emessa con l'Articolo 7 ter (operazione non soggetta, IVA 0%)."
    : "La fattura è stata emessa con IVA ordinaria al 22%.";
}
